"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewShareArrowFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M.9 10.022c1.486-3.846 4.514-5.24 7.093-5.565l.002-2.027c0-1.213 1.226-1.873 2.03-1.093l5.534 5.373c.581.564.59 1.597.016 2.173l-5.542 5.572c-.8.804-2.047.146-2.046-1.08l.001-1.713a13.82 13.82 0 00-1.5.087c-.22.026-.433.056-.64.091a9.633 9.633 0 00-2.524.777 7.823 7.823 0 00-2.054 1.405l-.018.018a7.536 7.536 0 00-.761.854c-.155.202-.501.095-.49-.159a21.585 21.585 0 01.012-.262c.018-.33.044-.649.077-.958l.001-.007.008-.076c.147-1.308.424-2.438.8-3.41z"
  })))
});
PreviewShareArrowFilledIcon.displayName = 'PreviewShareArrowFilledIcon';
var _default = exports.default = PreviewShareArrowFilledIcon;